import React from "react";
import { ConfirmSignUp } from "aws-amplify-react";
import { Redirect } from "react-router-dom";

export default class CustomConfirmSignUp extends ConfirmSignUp {
  showComponent() {
    return <Redirect to="/" />;
  }
}
